import { render, staticRenderFns } from "./index.vue?vue&type=template&id=04263d37"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04263d37')) {
      api.createRecord('04263d37', component.options)
    } else {
      api.reload('04263d37', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=04263d37", function () {
      api.rerender('04263d37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Stores/Editor/Taxes/index.vue"
export default component.exports